import { Routes, Route } from "react-router-dom";
import Loadable from "react-loadable";

// local import
import LoadingComponent from "./components/general/LoadingComponent";
import "./App.css";

const Homepage = Loadable({
  loader: () => import("./components/home/Homepage"),
  loading: LoadingComponent,
});

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
      </Routes>
    </div>
  );
}

export default App;
